import type { Analytics } from "@/types";
import React, { useMemo, useState } from "react";

import { SupText, SupChevronLeft, SupChevronRight } from "@repo/core-ui";
import { getDuneEmbeddedLink } from "@/utils/formatters";
import { twMerge } from "tailwind-merge";

export default function VaultDetailsDune({ slides, className }: { slides: Analytics[]; className?: string }) {
  const [current, setCurrent] = useState(0);

  const length = slides.length;
  const currentSlide = useMemo(() => slides[current], [current, slides]);

  const nextSlide = () => {
    setCurrent(current + 1);
  };

  const prevSlide = () => {
    setCurrent(current - 1);
  };

  return (
    <div className={twMerge("mx-6", className)}>
      <SupText family="mono" variant="subtitle1" className="mb-6">
        Vault analytics
      </SupText>
      <div className="relative">
        <button
          type="button"
          onClick={prevSlide}
          disabled={current === 0}
          className={twMerge(
            "inline-flex h-[40px] w-[40px] items-center justify-center bg-neutral-600",
            "group absolute left-0 top-1/2 text-neutral",
            current === 0 ? "cursor-not-allowed text-neutral opacity-70" : "lg:hover:text-primary-200"
          )}
        >
          <span className="sr-only">Previous chart</span>
          <SupChevronLeft />
        </button>
        <button
          type="button"
          onClick={nextSlide}
          disabled={current === length - 1}
          className={twMerge(
            "inline-flex h-[40px] w-[40px] items-center justify-center bg-neutral-600",
            "group absolute right-0 top-1/2 text-neutral",
            current === length - 1 ? "cursor-not-allowed text-neutral opacity-70" : "lg:hover:text-primary-200"
          )}
        >
          <span className="sr-only">Previous chart</span>
          <SupChevronRight />
        </button>
        <div className="mx-[48px] mb-7 flex flex-col">
          <iframe
            src={getDuneEmbeddedLink(currentSlide.chart_url)}
            className="h-[462px] w-full min-[393px]:h-[586px] min-[430px]:h-[650px] md:h-[160px] min-[834px]:h-[182px] lg:h-[231px]
                      xl:h-[297px] min-[1440px]:h-[338px] min-[1512px]:h-[356px] min-[1728px]:h-[403px]"
            title={currentSlide.chart_title}
          />
        </div>
      </div>
    </div>
  );
}
